import _toConsumableArray from "/Users/ned/Documents/solutions-engineer/se-dashboard/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
var rxArrIndex = /\D/;
var rxVarName = /^[a-zA-Z_$]+([\w_$]*)$/;
var rxQuot = /"/g;

function concatPaths() {
  for (var _len = arguments.length, paths = new Array(_len), _key = 0; _key < _len; _key++) {
    paths[_key] = arguments[_key];
  }

  return paths.reduce(function (acc, p) {
    return acc ? !p || p.startsWith('[') ? "".concat(acc).concat(p) : "".concat(acc, ".").concat(p) : p;
  }, '');
}

export default function getPathToString(_) {
  function pathToString(path) {
    for (var _len2 = arguments.length, prefixes = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      prefixes[_key2 - 1] = arguments[_key2];
    }

    if (_.isString(path)) return concatPaths.apply(void 0, _toConsumableArray(prefixes).concat([path]));
    if (!_.isArray(path)) return undefined;
    prefixes = concatPaths.apply(void 0, _toConsumableArray(prefixes));
    return path.reduce(function (acc, value) {
      var type = typeof value;

      if (type === 'number') {
        if (value < 0 || value % 1 !== 0) {
          return "".concat(acc, "[\"").concat(value, "\"]");
        } else {
          return "".concat(acc, "[").concat(value, "]");
        }
      } else if (type !== 'string') {
        return "".concat(acc, "[\"").concat(value, "\"]");
      } else if (!value) {
        return "".concat(acc, "[\"\"]");
      }

      if (!rxArrIndex.test(value)) {
        return "".concat(acc, "[").concat(value, "]");
      }

      if (rxVarName.test(value)) {
        if (acc) {
          return "".concat(acc, ".").concat(value);
        } else {
          return "".concat(acc).concat(value);
        }
      }

      return "".concat(acc, "[\"").concat(value.replace(rxQuot, '\\"'), "\"]");
    }, prefixes);
  }

  return pathToString;
}
getPathToString.notChainable = true;